import { Actions, AppMiddleware } from '..';
import { SET_SELECTED_COVER } from '../cover';
import { CheckoutAvailabilityService, StoreService } from '@inter-ikea-kompis/services';
import { FETCH_CONFIG_SUCCESS } from '../products';
import { setStockedIkeaPlus } from '../checkout';

const coverMiddleware: AppMiddleware =
	(api) =>
	(next) =>
	async (action: Actions): Promise<Actions> => {
		const result = next(action);
		const state = api.getState();
		const dispatch = api.dispatch;
		const settings = state.settings.settings;
		const products = Object.values(state.products.products);
		const covers = state.cover.coverItems;

		switch (action.type) {
			case SET_SELECTED_COVER:
			case FETCH_CONFIG_SUCCESS:
				const service = new CheckoutAvailabilityService({
					locale: settings.locale,
					localizationEndpoints: settings.localizationEndpoints,
				});
				const storeService = new StoreService({
					locale: settings.locale,
					localizationPrefixApplication: settings.localizationPrefixApplication,
					localizationEndpoints: settings.localizationEndpoints,
					consumer: settings.consumer,
					contract: settings.contract,
				});
				const stores = await storeService.getStores();
				const ikeaPlusCovers = covers.filter((cover) => cover.isIkeaPlus);

				if (ikeaPlusCovers.length > 0 && stores.length > 0) {
					const ikeaPlusProduct = products.find((product) => {
						if (product.filter.color === ikeaPlusCovers[0].coverName) {
							return product;
						}

						return false;
					});
					const storeId = stores[0].id;

					if (ikeaPlusProduct && storeId) {
						const ikeaPlusProductCheckout = {
							id: ikeaPlusProduct.localId ? ikeaPlusProduct.localId : ikeaPlusProduct.productId,
							type: 'SPR',
						};
						const availability = await service.getStoreAvailabilities(storeId, [
							ikeaPlusProductCheckout,
						]);
						const stock = availability[0].content.cashCarry;

						if (stock && stock.messageType) {
							if ((stock.messageType as string) !== 'UNKNOWN') {
								dispatch(setStockedIkeaPlus(true));
							} else {
								dispatch(setStockedIkeaPlus(false));
							}
						}
					}
				}

				break;
		}

		return result;
	};

export { coverMiddleware };
